import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Renew"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M9.00001 7.50004H5.08501C7.07711 4.43849 10.8452 3.0513 14.3469 4.09038C17.8486 5.12946 20.2502 8.34743 20.25 12H21.75C21.7542 7.89044 19.1812 4.2194 15.3166 2.82145C11.4521 1.42349 7.12593 2.5988 4.50001 5.76004V3.00004H3.00001V9.00004H9.00001V7.50004ZM15 16.5001H18.915C16.9229 19.5616 13.1548 20.9488 9.65308 19.9097C6.15138 18.8706 3.74977 15.6527 3.75001 12H2.25001C2.24577 16.1097 4.81884 19.7807 8.68337 21.1786C12.5479 22.5766 16.8741 21.4013 19.5 18.24V21.0001H21V15H15V16.5001Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Renew.vue"]]);
